import { shopManagerApi } from 'configs';
import api from 'configs/api';
import { chunkArray, convertToSearchCriteria } from 'helpers/api';
import {
  getStoreCustomerGroupsStart,
  getStoreCustomerGroupsSuccess,
  getStoreCustomerGroupsFailed,
  getStoreCustomerDefaultGroupStart,
  getStoreCustomerDefaultGroupSuccess,
  getStoreCustomerDefaultGroupFailed,
  editStoreCustomerDefaultGroupStart,
  editStoreCustomerDefaultGroupSuccess,
  editStoreCustomerDefaultGroupFailed,
  getStoreCustomersGridStart,
  getStoreCustomersGridSuccess,
  getStoreCustomersGridFailed,
  getStoreCustomerDataStart,
  getStoreCustomerDataSuccess,
  getStoreCustomerDataFailed,
  deleteCustomerAccountStart,
  deleteCustomerAccountSuccess,
  deleteCustomerAccountFailed,
  loginAsCustomerStart,
  loginAsCustomerSuccess,
  loginAsCustomerFailed,
  resetCustomerPasswordStart,
  resetCustomerPasswordSuccess,
  resetCustomerPasswordFailed,
  updateCustomerDataStart,
  updateCustomerDataSuccess,
  updateCustomerDataFailed,
  createCustomerStart,
  createCustomerSuccess,
  createCustomerFailed,
  getCustomerRewardsStart,
  getCustomerRewardsSuccess,
  getCustomerRewardsFailed,
  getCustomerRewardsBalanceStart,
  getCustomerRewardsBalanceSuccess,
  getCustomerRewardsBalanceFailed,
  updateCustomerRewardsBalanceStart,
  updateCustomerRewardsBalanceSuccess,
  updateCustomerRewardsBalanceFailed,
  getCustomersAccessListStart,
  getCustomersAccessListSuccess,
  getCustomersAccessListFailed,
  updateCustomersAccessStart,
  updateCustomersAccessSuccess,
  updateCustomersAccessFailed,
  getStoreCustomerCardDataStart,
  getStoreCustomerCardDataSuccess,
  getStoreCustomerCardDataFailed,
  getCustomerSubscriptionsStart,
  getCustomerSubscriptionsSuccess,
  getCustomerSubscriptionsFailed,
  getCustomerGiftCardTransactionsStart,
  getCustomerGiftCardTransactionsSuccess,
  getCustomerGiftCardTransactionsFailed,
  getCustomerGiftCardsBalanceStart,
  getCustomerGiftCardsBalanceSuccess,
  getCustomerGiftCardsBalanceFailed,
  updateCustomerGiftCardsBalanceStart,
  updateCustomerGiftCardsBalanceSuccess,
  updateCustomerGiftCardsBalanceFailed,
  addImportCustomersToQueueStart,
  addImportCustomersToQueueSuccess,
  addImportCustomersToQueueFailed,
  getCustomersImportQueueTasksStart,
  getCustomersImportQueueTasksSuccess,
  getCustomersImportQueueTasksFailed,
  deleteCustomerImportQueueTaskStart,
  deleteCustomerImportQueueTaskSuccess,
  deleteCustomerImportQueueTaskFailed,
  getCustomerActiveCreditCardsStart,
  getCustomerActiveCreditCardsSuccess,
  getCustomerActiveCreditCardsFailed,
  getExistingCustomersByEmailsStart,
  getExistingCustomersByEmailsSuccess,
  getExistingCustomersByEmailsFailed,

} from 'redux/actions/customers';


export const getStoreCustomerGroupsApi = async ({dispatch}) => {
  try {
    dispatch(getStoreCustomerGroupsStart());
    const { data } = await api.get(`${shopManagerApi}/store/groups/list`);
    dispatch(getStoreCustomerGroupsSuccess(data));
  } catch (e) {
    dispatch(getStoreCustomerGroupsFailed(e));
  }
};

export const getStoreCustomerDefaultGroupApi = async ({dispatch}) => {
  try {
    dispatch(getStoreCustomerDefaultGroupStart());
    const { data } = await api.get(`${shopManagerApi}/store/groups/default`);
    dispatch(getStoreCustomerDefaultGroupSuccess(data));
  } catch (e) {
    dispatch(getStoreCustomerDefaultGroupFailed(e));
  }
};

export const editStoreCustomerDefaultGroupApi = async ({dispatch, id, group}) => {
  try {
    dispatch(editStoreCustomerDefaultGroupStart());
    const { data } = await api.put(`${shopManagerApi}/store/group/${id}`, group);
    dispatch(editStoreCustomerDefaultGroupSuccess(data));
  } catch (e) {
    dispatch(editStoreCustomerDefaultGroupFailed(e));
  }
};

export const getStoreCustomersGridApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions,
  isCSVData = false
}) => {
  try {
    dispatch(getStoreCustomersGridStart(isCSVData));
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    const { data } = await api.get(`${shopManagerApi}/store/customers/grid?${params}`);
    dispatch(getStoreCustomersGridSuccess(data, isCSVData));
  } catch (e) {
    dispatch(getStoreCustomersGridFailed(e, isCSVData));
  }
};

const EXISTING_CUSTOMERS_EMAILS_CHUNK_SIZE = 200;

export const getExistingCustomersByEmailsApi = async ({dispatch, emails}) => {
  if (!emails.length) {
    return [];
  }

  try {
    dispatch(getExistingCustomersByEmailsStart());
    const emailChunks = chunkArray(emails, EXISTING_CUSTOMERS_EMAILS_CHUNK_SIZE);
    const responses = await Promise.all(emailChunks.map((emailChunk) => {
      const params = convertToSearchCriteria({
        searchConditions: [],
        filterConditions: [
          {
            field: 'email',
            value: emailChunk.join(','),
            conditionType: 'in'
          }
        ],
        pageSize: emailChunk.length,
        currentPage: 1
      });
      return api.get(`${shopManagerApi}/store/customers/grid?${params}`);
    }));

    dispatch(getExistingCustomersByEmailsSuccess());
    return responses.flatMap(({data}) => data.items || []);
  } catch (e) {
    dispatch(getExistingCustomersByEmailsFailed(e));
    return [];
  }
};

export const getStoreCustomerDataApi = async ({dispatch, id}) => {
  try {
    dispatch(getStoreCustomerDataStart());
    const { data } = await api.get(`${shopManagerApi}/store/customer/${id}`);
    dispatch(getStoreCustomerDataSuccess(data));
  } catch (e) {
    dispatch(getStoreCustomerDataFailed(e));
  }
};

export const deleteCustomerAccountApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteCustomerAccountStart());
    await api.delete(`${shopManagerApi}/store/customer/${id}`);
    dispatch(deleteCustomerAccountSuccess(id));
    return true;
  } catch (e) {
    dispatch(deleteCustomerAccountFailed(e));
    return false;
  }
};

export const loginAsCustomerApi = async ({dispatch, id}) => {
  try {
    dispatch(loginAsCustomerStart());
    const {data} = await api.get(`${shopManagerApi}/store/login-as-customer/${id}/url`);
    dispatch(loginAsCustomerSuccess(data.url));
  } catch (e) {
    dispatch(loginAsCustomerFailed(e));
  }
};

export const resetCustomerPasswordApi = async ({dispatch, email}) => {
  try {
    dispatch(resetCustomerPasswordStart());
    await api.post(`${shopManagerApi}/store/customer/reset-password`, {email});
    dispatch(resetCustomerPasswordSuccess());
  } catch (e) {
    dispatch(resetCustomerPasswordFailed(e));
  }
};

export const updateCustomerDataApi = async ({dispatch, customerId, customerData}) => {
  try {
    dispatch(updateCustomerDataStart());
    const {data} = await api.put(`${shopManagerApi}/store/customer/${customerId}`, customerData);
    dispatch(updateCustomerDataSuccess(data));
    return true;
  } catch (e) {
    dispatch(updateCustomerDataFailed(e));
    return false;
  }
};

export const createCustomerApi = async ({dispatch, customer}) => {
  try {
    dispatch(createCustomerStart());
    const {data} = await api.post(`${shopManagerApi}/store/customer`, {customer});
    dispatch(createCustomerSuccess(data));
    return true;
  } catch (e) {
    dispatch(createCustomerFailed(e));
    return false;
  }
};

export const getCustomerRewardsApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    dispatch(getCustomerRewardsStart());
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    const { data } = await api.get(`${shopManagerApi}/store/customer/reward/transactions?${params}`);
    dispatch(getCustomerRewardsSuccess(data));
  } catch (e) {
    dispatch(getCustomerRewardsFailed(e));
  }
};

export const getCustomerRewardsBalanceApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    dispatch(getCustomerRewardsBalanceStart());
    const { data } = await api.get(`${shopManagerApi}/store/customer/reward/balance?${params}`);
    dispatch(getCustomerRewardsBalanceSuccess(data));
  } catch (e) {
    dispatch(getCustomerRewardsBalanceFailed(e));
  }
};

export const updateCustomerRewardsBalanceApi = async ({
  dispatch,
  balance
}) => {
  try {
    dispatch(updateCustomerRewardsBalanceStart());
    await api.put(`${shopManagerApi}/store/customer/reward/balance`, balance);
    dispatch(updateCustomerRewardsBalanceSuccess(balance));
    return true;
  } catch (e) {
    dispatch(updateCustomerRewardsBalanceFailed(e));
    return false;
  }
};

export const getCustomerGiftCardTransactionsApi = async ({
  dispatch,
  customerId,
  sortDirection,
  sortField,
  pageSize,
  currentPage
}) => {
  try {
    const params = convertToSearchCriteria({
      searchConditions: [],
      filterConditions: [],
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    dispatch(getCustomerGiftCardTransactionsStart());
    const { data } = await api.get(`${shopManagerApi}/store/customer/giftcard/transactions/${customerId}?${params}`);
    dispatch(getCustomerGiftCardTransactionsSuccess(data));
  } catch (e) {
    dispatch(getCustomerGiftCardTransactionsFailed(e));
  }
};

export const getCustomerGiftCardsBalanceApi = async ({
  dispatch,
  customerId
}) => {
  try {
    dispatch(getCustomerGiftCardsBalanceStart());
    const { data } = await api.get(`${shopManagerApi}/store/customer/giftcard/balance/${customerId}`);
    dispatch(getCustomerGiftCardsBalanceSuccess(data));
  } catch (e) {
    dispatch(getCustomerGiftCardsBalanceFailed(e));
  }
};

export const updateCustomerGiftCardsBalanceApi = async ({
  dispatch,
  balance
}) => {
  try {
    dispatch(updateCustomerGiftCardsBalanceStart());
    await api.put(`${shopManagerApi}/store/customer/giftcard/balance`, balance);
    dispatch(updateCustomerGiftCardsBalanceSuccess(balance));
    return true;
  } catch (e) {
    dispatch(updateCustomerGiftCardsBalanceFailed(e));
    return false;
  }
};

export const getStoreRequestAccessListApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    dispatch(getCustomersAccessListStart());
    const { data } = await api.get(`${shopManagerApi}/store/request-access/list?${params}`);
    dispatch(getCustomersAccessListSuccess(data));
  } catch (e) {
    dispatch(getCustomersAccessListFailed(e));
  }
};

export const updateRequestRestrictAccessApi = async ({dispatch, updatedParamsAccess}) => {
  try {
    dispatch(updateCustomersAccessStart());
    await api.put(`${shopManagerApi}/store/request-access`, updatedParamsAccess);
    dispatch(updateCustomersAccessSuccess(updatedParamsAccess));
    return true;
  } catch (e) {
    dispatch(updateCustomersAccessFailed(e));
    return false;
  }
};

export const getStoreCustomerCardDataApi = async ({dispatch, id}) => {
  try {
    dispatch(getStoreCustomerCardDataStart());
    const { data } = await api.get(`${shopManagerApi}/store/splitpayment/credit-card/${id}`);
    dispatch(getStoreCustomerCardDataSuccess(data));
  } catch (e) {
    dispatch(getStoreCustomerCardDataFailed(e));
  }
};

export const getCustomerActiveCreditCardsApi = async ({dispatch, id}) => {
  try {
    dispatch(getCustomerActiveCreditCardsStart());
    const { data } = await api.get(`${shopManagerApi}/store/customer/active-credit-cards/${id}`);
    dispatch(getCustomerActiveCreditCardsSuccess(data));
  } catch (e) {
    dispatch(getCustomerActiveCreditCardsFailed(e));
  }
};

export const getCustomerSubscriptionsApi = async ({
  dispatch,
  sortDirection,
  sortField,
  pageSize,
  currentPage,
  searchConditions,
  filterConditions
}) => {
  try {
    const params = convertToSearchCriteria({
      searchConditions,
      filterConditions,
      pageSize,
      currentPage,
      sortField,
      sortDirection
    });
    dispatch(getCustomerSubscriptionsStart());
    const { data } = await api.get(`${shopManagerApi}/store/subscription?${params}`);
    dispatch(getCustomerSubscriptionsSuccess(data));
  } catch (e) {
    dispatch(getCustomerSubscriptionsFailed(e));
  }
};

export const addImportCustomersToQueueApi = async ({
  dispatch,
  tasks,
  fileName
}) => {
  try {
    dispatch(addImportCustomersToQueueStart());
    const {data} = await api.post(`${shopManagerApi}/customer-import/queue`, tasks);
    dispatch(addImportCustomersToQueueSuccess(data.tasks, fileName));
    return true;
  } catch (e) {
    dispatch(addImportCustomersToQueueFailed(e));
    return false;
  }
};

export const getCustomersImportQueueTasksApi = async ({
  dispatch,
  storeViewCode
}) => {
  try {
    dispatch(getCustomersImportQueueTasksStart());
    const { data } = await api.get(`${shopManagerApi}/customer-import/queue?storeViewCode=${storeViewCode}`);
    dispatch(getCustomersImportQueueTasksSuccess(data));
    return true;
  } catch (e) {
    dispatch(getCustomersImportQueueTasksFailed(e));
    return false;
  }
};

export const deleteCustomerImportQueueTaskApi = async ({
  dispatch,
  id
}) => {
  try {
    dispatch(deleteCustomerImportQueueTaskStart());
    await api.delete(`${shopManagerApi}/customer-import/queue/${id}`);
    dispatch(deleteCustomerImportQueueTaskSuccess(id));
    return true;
  } catch (e) {
    dispatch(deleteCustomerImportQueueTaskFailed(e));
    return false;
  }
};
